/**
 * B2: employee `photo_url` is admin-supplied and gets interpolated into a
 * CSS `url("...")` background (avatar crop/zoom needs backgroundImage, not
 * <img>, for the focal-point positioning). An unvalidated value lets a
 * crafted string break out of the CSS string and inject arbitrary
 * declarations. Reject non-https values and escape quotes/backslashes so
 * nothing can break out of the `url("...")` wrapper.
 */
export function safeBackgroundImage(url: string | null | undefined): string | undefined {
  if (!url || !url.startsWith("https://")) return undefined;
  const escaped = url.replace(/[\\"]/g, (c) => "\\" + c);
  return `url("${escaped}")`;
}
